// /**
//  * section-slideshow.js
//  *
//  * Fixes the "Adapt to first image" height bugs:
//  *  - Liquid can only guess the aspect ratio from image metadata, which is
//  *    sometimes missing and never accounts for the mobile image differing
//  *    from the desktop image. The CSS `aspect-ratio: var(--aspect-desktop)`
//  *    / `var(--aspect-mobile)` set inline from Liquid is the CLS-safe
//  *    first paint; this script *upgrades* that guess to the real,
//  *    measured image dimensions once each image is available, and keeps it
//  *    correct across the desktop/mobile breakpoint and window resizes.
//  *
//  * Does not touch fixed-height modes (450/550/650/750/full/full-header) —
//  * those never carry data-adapt-height="true" and this script no-ops for them.
//  */
// (function () {
//   'use strict';

//   var MOBILE_QUERY = '(max-width:749px)';
//   var measuredCache = new WeakMap(); // element -> {url: ratio}

//   function firstUrlFromBgset(bgset) {
//     if (!bgset) return null;
//     // bgset format: "url1 100w, url2 200w, ..." — take the first candidate.
//     var first = bgset.split(',')[0].trim().split(' ')[0];
//     return first || null;
//   }

//   function measureRatio(el) {
//     return new Promise(function (resolve) {
//       if (!el) return resolve(null);

//       // Background-image element populated by lazysizes bgset/currentSrc.
//       var url =
//         el.currentSrc ||
//         (el.style && el.style.backgroundImage
//           ? el.style.backgroundImage.replace(/^url\(["']?/, '').replace(/["']?\)$/, '')
//           : null) ||
//         firstUrlFromBgset(el.getAttribute('data-bgset'));

//       // <img> element fallback (non-adaptive-cover mobile mode).
//       if (!url && el.tagName === 'IMG') {
//         url = el.currentSrc || el.src || el.getAttribute('data-src');
//       }

//       if (!url) return resolve(null);

//       var cache = measuredCache.get(el) || {};
//       if (cache[url]) return resolve(cache[url]);

//       var img = new Image();
//       img.onload = function () {
//         if (img.naturalWidth && img.naturalHeight) {
//           var ratio = img.naturalWidth / img.naturalHeight;
//           cache[url] = ratio;
//           measuredCache.set(el, cache);
//           resolve(ratio);
//         } else {
//           resolve(null);
//         }
//       };
//       img.onerror = function () {
//         resolve(null);
//       };
//       img.src = url;
//     });
//   }

//   function firstSlide(wrapper) {
//     return wrapper.querySelector('.slideshow__slide, .slide');
//   }

//   function pickImageEl(slide, isMobile) {
//     if (!slide) return null;
//     if (isMobile) {
//       return (
//         slide.querySelector('.img_mobile.slideshow__image') ||
//         slide.querySelector('.img_mobile img') ||
//         slide.querySelector('.slideshow__image')
//       );
//     }
//     return slide.querySelector(
//       '.slideshow__image:not(.img_mobile):not(.d-none)'
//     ) || slide.querySelector('.slideshow__image');
//   }

//   function refresh(wrapper) {
//     var isMobile = window.matchMedia(MOBILE_QUERY).matches;
//     var slide = firstSlide(wrapper);
//     var el = pickImageEl(slide, isMobile);

//     measureRatio(el).then(function (ratio) {
//       if (!ratio) return; // keep the Liquid-computed fallback
//       var prop = isMobile ? '--aspect-mobile' : '--aspect-desktop';
//       var current = wrapper.style.getPropertyValue(prop);
//       var next = ratio.toFixed(4);
//       if (current !== next) {
//         wrapper.style.setProperty(prop, next);
//       }
//     });
//   }

//   function debounce(fn, wait) {
//     var t;
//     return function () {
//       clearTimeout(t);
//       var args = arguments;
//       var ctx = this;
//       t = setTimeout(function () {
//         fn.apply(ctx, args);
//       }, wait);
//     };
//   }

//   function init() {
//     var wrappers = document.querySelectorAll(
//       '.slideshow[data-adapt-height="true"]'
//     );
//     if (!wrappers.length) return;

//     wrappers.forEach(function (wrapper) {
//       refresh(wrapper);

//       // Lazysizes fires this once a bg image / img finishes loading.
//       wrapper.addEventListener('lazyloaded', function (e) {
//         if (firstSlide(wrapper).contains(e.target) || e.target === firstSlide(wrapper)) {
//           refresh(wrapper);
//         }
//       });

//       var onResize = debounce(function () {
//         refresh(wrapper);
//       }, 150);
//       window.addEventListener('resize', onResize);
//     });
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }
// })();










































/**
 * section-slideshow.js
 *
 * Fixes the "Adapt to first image" height bugs:
 *  - Liquid can only guess the aspect ratio from image metadata, which is
 *    sometimes missing and never accounts for the mobile image differing
 *    from the desktop image. The CSS `aspect-ratio: var(--aspect-desktop)`
 *    / `var(--aspect-mobile)` set inline from Liquid is the CLS-safe
 *    first paint; this script *upgrades* that guess to the real,
 *    measured image dimensions once each image is available, and keeps it
 *    correct across the desktop/mobile breakpoint and window resizes.
 *
 * Does not touch fixed-height modes (450/550/650/750/full/full-header) —
 * those never carry data-adapt-height="true" and this script no-ops for them.
 */
(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width:749px)';
  var measuredCache = new WeakMap(); // element -> {url: ratio}

  function firstUrlFromBgset(bgset) {
    if (!bgset) return null;
    // bgset format: "url1 100w, url2 200w, ..." — take the first candidate.
    var first = bgset.split(',')[0].trim().split(' ')[0];
    return first || null;
  }

  function measureRatio(el) {
    return new Promise(function (resolve) {
      if (!el) return resolve(null);

      // Background-image element populated by lazysizes bgset/currentSrc.
      var url =
        el.currentSrc ||
        (el.style && el.style.backgroundImage
          ? el.style.backgroundImage.replace(/^url\(["']?/, '').replace(/["']?\)$/, '')
          : null) ||
        firstUrlFromBgset(el.getAttribute('data-bgset'));

      // <img> element fallback (non-adaptive-cover mobile mode).
      if (!url && el.tagName === 'IMG') {
        url = el.currentSrc || el.src || el.getAttribute('data-src');
      }

      if (!url) return resolve(null);

      var cache = measuredCache.get(el) || {};
      if (cache[url]) return resolve(cache[url]);

      var img = new Image();
      img.onload = function () {
        if (img.naturalWidth && img.naturalHeight) {
          var ratio = img.naturalWidth / img.naturalHeight;
          cache[url] = ratio;
          measuredCache.set(el, cache);
          resolve(ratio);
        } else {
          resolve(null);
        }
      };
      img.onerror = function () {
        resolve(null);
      };
      img.src = url;
    });
  }

  function firstSlide(wrapper) {
    return wrapper.querySelector('.slideshow__slide, .slide');
  }

  function pickImageEl(slide, isMobile) {
    if (!slide) return null;
    if (isMobile) {
      return (
        slide.querySelector('.img_mobile.slideshow__image') ||
        slide.querySelector('.img_mobile img') ||
        slide.querySelector('.slideshow__image')
      );
    }
    return slide.querySelector(
      '.slideshow__image:not(.img_mobile):not(.d-none)'
    ) || slide.querySelector('.slideshow__image');
  }

  function refresh(wrapper) {
    var isMobile = window.matchMedia(MOBILE_QUERY).matches;
    var slide = firstSlide(wrapper);
    var el = pickImageEl(slide, isMobile);

    measureRatio(el).then(function (ratio) {
      if (!ratio) return; // keep the Liquid-computed fallback
      var prop = isMobile ? '--aspect-mobile' : '--aspect-desktop';
      var current = wrapper.style.getPropertyValue(prop);
      var next = ratio.toFixed(4);
      if (current !== next) {
        wrapper.style.setProperty(prop, next);
        if (typeof jQuery !== 'undefined') {
          var $slider = jQuery(wrapper);
          if ($slider.hasClass('slick-initialized')) {
            $slider.slick('setPosition');
          }
        }
      }
    });
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      var args = arguments;
      var ctx = this;
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  function init() {
    var wrappers = document.querySelectorAll(
      '.slideshow[data-adapt-height="true"]'
    );
    if (!wrappers.length) return;

    wrappers.forEach(function (wrapper) {
      refresh(wrapper);

      // Lazysizes fires this once a bg image / img finishes loading.
      wrapper.addEventListener('lazyloaded', function (e) {
        var slide = firstSlide(wrapper);
        if (slide && (slide.contains(e.target) || e.target === slide)) {
          refresh(wrapper);
        }
      });

      var onResize = debounce(function () {
        refresh(wrapper);
      }, 150);
      window.addEventListener('resize', onResize);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', init);

  // Support Shopify Theme Editor section reloads
  document.addEventListener('shopify:section:load', function () {
    init();
  });

  // Passive emergency fallback: ONLY if theme.js did not run after 1.5s
  setTimeout(function () {
    if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') return;
    var $ = jQuery;
    $('.slideshow:not(.slick-initialized)').each(function () {
      var $slider = $(this);
      var $section = $slider.closest('[data-section-type="slideshow-section"]');
      if ($section.length && window.theme && window.theme.SlideshowSection) {
        try {
          new window.theme.SlideshowSection($section[0]);
        } catch (e) {
          console.warn('[Slideshow] Fallback init:', e);
        }
      }
    });
  }, 1500);
})();